import { useRef } from 'react';

import { useLegalClientSaveGlobalFinancialMonitoringPartOne } from 'api/requests';
import { useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';

import { CompanyGlobalFinancialMonitoringPartOneFormType } from '../forms/companyGlobalFinancialMonitoringPartOneForm';
import {
  getInitialData,
  getSubmitData,
} from '../helpers/companyGlobalFinancialMonitoringPartOne';

import { useOnboardingContext } from './useOnboardingContext';

export const useCompanyGlobalFinancialMonitoringPartOne = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const { error, loading, saveFinancialMonitoring } =
    useLegalClientSaveGlobalFinancialMonitoringPartOne();
  const { t } = useTranslation();

  const initialValues = useRef(
    getInitialData(t, data.legalClient!.financialMonitoring)
  ).current;

  const onSubmit = async (
    values: CompanyGlobalFinancialMonitoringPartOneFormType
  ) => {
    if (values) {
      const submitData = getSubmitData(values);
      await saveFinancialMonitoring(data.legalClient!.id, submitData);
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    onSubmit,
    goToBack,
    submitLoading: loading,
    initialValues,
  };
};
